import { useGetTheme } from '@pba/react-theme';
import { Progress as ProgressAD, type ProgressProps } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import styles from './progress.module.css';

export type ProgressBarColor = 'error' | 'success' | 'warning';

export type ProgressProperties = {
  color?: ProgressBarColor;
  size?: 'extra-small' | ProgressProps['size'];
} & Omit<ComponentProps<typeof ProgressAD>, 'size'>;

const Progress = ({ className, color, size, ...rest }: ProgressProperties) => {
  const { spacing } = useGetTheme();

  return (
    <ProgressAD
      className={cn(
        styles.progress,
        {
          [styles.error ?? '']: color === 'error',
          [styles.success ?? '']: color === 'success',
          [styles.warning ?? '']: color === 'warning',
        },
        className,
      )}
      size={size === 'extra-small' ? { height: spacing.xxs.value } : size}
      {...rest}
    />
  );
};

export default Progress;
